__turbopack_context__.v({
  "btnContainer": "join-group-client-module__JoA1eq__btnContainer",
  "content": "join-group-client-module__JoA1eq__content",
  "downloadBtns": "join-group-client-module__JoA1eq__downloadBtns",
  "hero": "join-group-client-module__JoA1eq__hero",
  "noiseBg": "join-group-client-module__JoA1eq__noiseBg",
  "scaleAnim": "join-group-client-module__JoA1eq__scaleAnim",
  "subtitle": "join-group-client-module__JoA1eq__subtitle",
  "uhLogo": "join-group-client-module__JoA1eq__uhLogo",
});
